module.exports = __webpack_public_path__ + "img/7.b36223e0.png";